import React from "react"
import Lottie from "@shared/uiNew/LazyLottie"

import ProcessStepsSection from "@shared/uiNew/ProcessStepsSection"

import lineAnimation from "@/shared/animations/3_lines.json"
import sales_1 from "../assets/sales_1.png"
import sales_2 from "../assets/sales_2.png"

import * as styles from "../styles.module.scss"

const Sales = (props) => (
  <ProcessStepsSection
    title={titleSales}
    description={salesDesc}
    sectionClassName={styles.salesSection}
    steps={salesArray}
    bubble={salesBubble}
    styleButtonWrapper={styles.buttonsWrapper}
    secondButtonProps={{
      text: "Оставить заявку на демо",
    }}
    buttonProps={{
      text: "Больше сценариев для продаж",
      href: "/ready-made-scenarios-library/",
      variant: "outline",
      icon: "arrow",
    }}
  />
)

export default Sales

const titleSales = (
  <h2 className={`${styles.salesTitle} h1`}>
    Конвертируйте обращения в продажи
    <span className={styles.salesHighlight}>
      <Lottie animationData={lineAnimation} loop={false} autoplay />
    </span>
  </h2>
)

const salesBubble = (
  <h4 className={styles.bubble}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99523 4H14.0052C17.7852 4 19.6752 4 20.8502 5.172C21.6602 5.978 21.9112 7.123 21.9902 8.989C22.0052 9.359 22.0132 9.545 21.9442 9.668C21.8742 9.791 21.5992 9.946 21.0472 10.254C20.7363 10.4273 20.4773 10.6806 20.297 10.9875C20.1167 11.2945 20.0216 11.644 20.0216 12C20.0216 12.356 20.1167 12.7055 20.297 13.0125C20.4773 13.3194 20.7363 13.5727 21.0472 13.746C21.5992 14.055 21.8752 14.209 21.9442 14.332C22.0132 14.455 22.0052 14.64 21.9892 15.01C21.9112 16.877 21.6592 18.022 20.8502 18.828C19.6762 20 17.7862 20 14.0052 20H9.99523C6.21523 20 4.32523 20 3.15023 18.828C2.34023 18.022 2.08923 16.877 2.01023 15.011C1.99523 14.641 1.98723 14.455 2.05623 14.332C2.12623 14.209 2.40123 14.055 2.95323 13.746C3.26416 13.5727 3.52317 13.3194 3.70347 13.0125C3.88378 12.7055 3.97884 12.356 3.97884 12C3.97884 11.644 3.88378 11.2945 3.70347 10.9875C3.52317 10.6806 3.26416 10.4273 2.95323 10.254C2.40123 9.946 2.12523 9.791 2.05623 9.668C1.98723 9.545 1.99523 9.36 2.01123 8.989C2.08923 7.123 2.34123 5.979 3.15023 5.172C4.32423 4 6.21423 4 9.99523 4ZM15.5482 8.47C15.6887 8.61063 15.7676 8.80125 15.7676 9C15.7676 9.19875 15.6887 9.38937 15.5482 9.53L9.53323 15.53C9.39209 15.6706 9.20097 15.7496 9.00173 15.7496C8.80249 15.7496 8.61137 15.6706 8.47023 15.53C8.32978 15.3894 8.25089 15.1988 8.25089 15C8.25089 14.8012 8.32978 14.6106 8.47023 14.47L14.4852 8.47C14.6264 8.32937 14.8175 8.2504 15.0167 8.2504C15.216 8.2504 15.4071 8.32937 15.5482 8.47ZM14.5152 15.5C14.6503 15.506 14.7852 15.4847 14.9118 15.4371C15.0384 15.3896 15.1541 15.3169 15.2518 15.2235C15.3495 15.13 15.4273 15.0177 15.4804 14.8934C15.5336 14.769 15.561 14.6352 15.561 14.5C15.561 14.3648 15.5336 14.231 15.4804 14.1066C15.4273 13.9823 15.3495 13.87 15.2518 13.7765C15.1541 13.6831 15.0384 13.6104 14.9118 13.5629C14.7852 13.5153 14.6503 13.494 14.5152 13.5C13.9612 13.5 13.5122 13.948 13.5122 14.5C13.5122 15.052 13.9622 15.5 14.5152 15.5ZM9.50223 10.5C10.0562 10.5 10.5052 10.052 10.5052 9.5C10.5052 8.948 10.0562 8.5 9.50223 8.5C9.36715 8.49396 9.23224 8.51535 9.10565 8.56288C8.97906 8.61041 8.86341 8.68309 8.76568 8.77654C8.66795 8.87 8.59017 8.98228 8.53703 9.10662C8.48389 9.23096 8.4565 9.36478 8.4565 9.5C8.4565 9.63522 8.48389 9.76904 8.53703 9.89338C8.59017 10.0177 8.66795 10.13 8.76568 10.2235C8.86341 10.3169 8.97906 10.3896 9.10565 10.4371C9.23224 10.4847 9.36715 10.506 9.50223 10.5Z"
        fill="#00B853"
      />
    </svg>
    Для продаж
  </h4>
)

const salesDesc = (
  <p className={styles.salesSubtitle}>
    Растите выручку за счет персонализированных демо-встреч — изучите контекст поведения лида на сайте и его обращения в поддержку, ведите коммуникацию прямо
    из вашей CRM-системы, без переключения между сервисами.
  </p>
)

const salesArray = [
  {
    id: 1,
    title: "Квалификация и запись на встречу",
    text: "Сохраняйте лучшие скрипты и отвечайте на частые вопросы в один клик. Скорость растет, а качество сервиса остается стабильно высоким. Чат-бот даст пользователю дополнительную информацию о продукте, проведет первичную квалификацию, назначит встречу с менеджером и передаст необходимые данные лида в CRM.",
    image: sales_1,
    imageAlt: "Квалификация и запись на встречу",
  },
  {
    id: 2,
    title: "Передача данных в CRM",
    text: "Чат-бот собирает всю необходимую информацию и при настройке интеграции с вашей CRM-системой передает все данные в настроенные поля. Таким образом, данные собираются в одном месте, а у менеджера по продажам всегда есть контекст для встречи.",
    image: sales_2,
    imageAlt: "Передача данных в CRM",
  },
]
